<h2 mat-dialog-title>Välj område</h2>

<mat-dialog-content>
  <p class="dialog-description">Välj område för att hämta standardprestationer.</p>

  <mat-radio-group [value]="selectedArea" (change)="onSelectionChange($event)">
    @for (option of data.options; track option) {
      <mat-radio-button class="area-option" [value]="option.value">
        {{ option.label }}
      </mat-radio-button>
    }
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Avbryt</button>
  <button mat-raised-button color="primary" type="button" (click)="confirm()"
  [disabled]="selectedArea === null">Välj</button>
</mat-dialog-actions>